import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { UserPlus } from 'lucide-react'

export default function AddStudent() {
  const navigate = useNavigate()
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState({
    english_name: '', chinese_name: '', date_of_birth: '',
    current_school: '', grade_when_joined: '', us_citizen: false,
    email: '', line_id: '', line_group_id: '', home_address: '',
    parent_name: '', parent_contact: '', parent_email: '', parent_line_id: '',
    join_date: new Date().toISOString().split('T')[0],
    status: 'Active',
  })

  const f = (key) => ({
    value: form[key] || '',
    onChange: e => setForm(p => ({ ...p, [key]: e.target.value }))
  })

  const save = async () => {
    if (!form.english_name) return alert('English name is required')
    setSaving(true)
    const { data, error } = await supabase.from('students').insert(form).select().single()
    setSaving(false)
    if (data) navigate(`/student/${data.id}`)
    else alert('Error saving student: ' + error?.message)
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Add new student</div>
          <div className="page-subtitle">Fill in the student's information to create their profile</div>
        </div>
        <div className="header-actions">
          <button className="btn" onClick={() => navigate('/')}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            <UserPlus size={14}/>
            {saving ? 'Saving...' : 'Create student'}
          </button>
        </div>
      </div>

      <div className="page-content">
        <div className="card">
          <div className="card-header"><span className="card-title">Personal information</span></div>
          <div className="card-body">
            <div className="form-grid">
              <div className="form-group"><div className="form-label">English name *</div><input className="form-input" placeholder="e.g. Ethan Chiu" {...f('english_name')}/></div>
              <div className="form-group"><div className="form-label">Chinese name</div><input className="form-input" placeholder="e.g. 邱泓銘" {...f('chinese_name')}/></div>
              <div className="form-group"><div className="form-label">Date of birth</div><input type="date" className="form-input" {...f('date_of_birth')}/></div>
              <div className="form-group"><div className="form-label">US Citizen</div>
                <select className="form-input" value={form.us_citizen ? 'true':'false'} onChange={e => setForm(p=>({...p,us_citizen:e.target.value==='true'}))}>
                  <option value="false">No</option><option value="true">Yes</option>
                </select>
              </div>
              <div className="form-group"><div className="form-label">Current school</div><input className="form-input" placeholder="e.g. Taipei American School" {...f('current_school')}/></div>
              <div className="form-group"><div className="form-label">Grade when joining</div>
                <select className="form-input" {...f('grade_when_joined')}>
                  <option value="">Select grade</option>
                  {[8,9,10,11,12].map(g => <option key={g} value={g}>Grade {g}</option>)}
                </select>
              </div>
              <div className="form-group"><div className="form-label">Email</div><input type="email" className="form-input" placeholder="student@email.com" {...f('email')}/></div>
              <div className="form-group"><div className="form-label">LINE ID</div><input className="form-input" placeholder="LINE display ID" {...f('line_id')}/></div>
              <div className="form-group" style={{gridColumn:'1/-1'}}><div className="form-label">Home address</div><input className="form-input" placeholder="Full address" {...f('home_address')}/></div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><span className="card-title">Parent / Guardian</span></div>
          <div className="card-body">
            <div className="form-grid">
              <div className="form-group"><div className="form-label">Parent name</div><input className="form-input" {...f('parent_name')}/></div>
              <div className="form-group"><div className="form-label">Parent contact</div><input className="form-input" placeholder="+886..." {...f('parent_contact')}/></div>
              <div className="form-group"><div className="form-label">Parent email</div><input type="email" className="form-input" {...f('parent_email')}/></div>
              <div className="form-group"><div className="form-label">Parent LINE ID</div><input className="form-input" {...f('parent_line_id')}/></div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><span className="card-title">Program</span></div>
          <div className="card-body">
            <div className="form-grid">
              <div className="form-group"><div className="form-label">Join date</div><input type="date" className="form-input" {...f('join_date')}/></div>
              <div className="form-group"><div className="form-label">LINE Group ID</div><input className="form-input" placeholder="C..." {...f('line_group_id')}/></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
